import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import styled from 'styled-components';

import SimpleArtist from '@common/types/artist/simple-artist';

import AppState from '@webapp/store/state';
import { SetActiveArtist } from '@webapp/store/artist/action-creators';

import ArtistListItem from '@components/artist/artist-list-item/index';
import Flex from '@components/layout/flex';

interface ArtistMenuSelectorCtrlProps {
  className?: string;
  artists: SimpleArtist[];
  setActive: (artist: SimpleArtist) => SetActiveArtist;
  activeArtist?: string;
  labelName?: string;
}

const mapStateToProps = (state: AppState) => ({
  activeArtist: state.artist.active?.id,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setActive: (artist: SimpleArtist) => dispatch(new SetActiveArtist(artist)),
});

export const ArtistMenuSelectorCtrl: React.FC<ArtistMenuSelectorCtrlProps> = (
  props
) => {
  const handleClick = (artist: SimpleArtist) => {
    if (!artist.id) {
      return;
    }
    if (artist.id !== props.activeArtist) {
      props.setActive(artist);
    }
  };

  return (
    <>
      {props.artists.map((artist) => (
        <div
          className={props.className}
          key={`artist-menu-list-item-${artist.id}`}
        >
          <Wrapper justifyContent="flex-start" alignItems="center">
            <ArtistListItem
              className={`artist-item ${
                artist.id === props.activeArtist ? 'open' : ''
              }`}
              artist={artist}
              labelName={props.labelName}
              isSelected={artist.id === props.activeArtist}
              onClick={() => handleClick(artist)}
              noTruncate
            />
          </Wrapper>
          <Divider />
        </div>
      ))}
    </>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(ArtistMenuSelectorCtrl)``);

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.primary};
  opacity: 0.1;
`;

const Wrapper = styled(Flex)`
  width: 100%;
  margin: 16px 0;

  .arrow {
    margin-right: 10px;
  }

  .artist-item {
    width: 100%;
    padding-left: 0;

    &.open {
      margin-bottom: 0;
    }

    @media ${({ theme }) => theme.device.tablet} {
      margin-right: 72px;
    }
  }
`;
